export default function riskStatus(status) {
    switch (status) {
        case 'draft': return 'Draft';
        case 'peer_review': return 'Peer review';
        case 'live': return 'Live';
        case 'requested': return 'Requested';
        case 'in_the_market': return 'In the market';
        case 'reviewing': return 'Reviewing';
        case 'firm_order': return 'Firm order';
        case 'offered': return 'Offered';
        case 'accepted': return 'Accepted';
        case 'approved': return 'Approved';
        case 'declined': return 'Declined';
        case 'ntu': return 'NTU';
        case 'expired': return 'Expired';
        case 'cancelled': return 'Cancelled';
        case 'closed': return 'Closed';
        case 'firm_ordered': return 'Firm ordered';
        case 'bound': return 'Bound';
        case 'query': return 'Query';
        case 'off_risk': return 'Off Risk';
        case 'archived': return 'Archived';
        case 'rejected': return 'Rejected';

        default: return status;
    }
}
